module.exports = __webpack_public_path__ + "static/media/030.8d6a0011.jpg";